import { type PDFFont } from "pdf-lib"

export function normalizeCertificateText (text: string): string {
    return text.replace(/\s+/g, " ").trim()
}

export function fitText (
    value: string,
    font: Pick<PDFFont, "widthOfTextAtSize">,
    availableWidth: number,
    preferredSize: number,
    minimumSize: number
): { text: string, size: number } {
    const text = normalizeCertificateText(value)
    const preferredWidth = font.widthOfTextAtSize(text, preferredSize)
    // Allow floating-point noise without needlessly shrinking an exact-fit field (e.g. the year).
    if (preferredWidth <= availableWidth + 0.001) return { text, size: preferredSize, }

    const size = Math.floor(preferredSize * availableWidth / preferredWidth * 100) / 100
    if (size < minimumSize) {
        throw new Error("Текст слишком длинный для сертификата: не удаётся разместить его полностью читаемым шрифтом.")
    }
    return { text, size, }
}
